<template>
  <v-avatar
    :color="color"
    :size="size"
    @click="click"
  >
    <avatarBody
      :photoUrl="photoUrl"
      :name="name"
    ></avatarBody>
  </v-avatar>
</template>

<script>
import AvatarBody from '@/components/Like/AvatarBody'

export default {
  components: {
    AvatarBody,
  },
  props: {
    photoUrl: { type: String, require: true },
    name: { type: String, require: true },
    size: { type: String, require: false, default: '62' },
    color: { type: String, require: false, default: 'white'}
  },
  computed: {
    isSPSize() {
      return this.$vuetify.breakpoint.name === 'xs'
    },
  },
  methods: {
    click(e) {
      this.$emit('click', e)
    }
  },
};
</script>
